<script>
import AssignStudyGroup from "@/EventLogic/components/actions/assignStudyGroup.vue";

export default {
  extends: AssignStudyGroup,
  props: {
    id: String,
    study_group_category_id: [Number, String],
    study_group_id: [Number, String]
  },
}

</script>